import { render, staticRenderFns } from "./AutoCloseInfo.vue?vue&type=template&id=4b3efb84&scoped=true"
import script from "./AutoCloseInfo.vue?vue&type=script&lang=js"
export * from "./AutoCloseInfo.vue?vue&type=script&lang=js"
import style0 from "./AutoCloseInfo.vue?vue&type=style&index=0&id=4b3efb84&prod&scoped=true&lang=css"
import style1 from "./AutoCloseInfo.vue?vue&type=style&index=1&id=4b3efb84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3efb84",
  null
  
)

export default component.exports